/* nue daily — free shipping bar live updater */
(function () {
  'use strict';

  var THRESHOLD_CENTS = 9900;

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function refresh() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var total = cart.total_price;
        var remaining = Math.max(THRESHOLD_CENTS - total, 0);
        var progress = Math.min((total / THRESHOLD_CENTS) * 100, 100);
        document.querySelectorAll('.nue-shipping-label').forEach(function (el) {
          el.textContent = remaining > 0
            ? formatMoney(remaining) + ' away from free shipping'
            : 'free shipping unlocked';
        });
        document.querySelectorAll('.nue-shipping-fill').forEach(function (el) {
          el.style.width = progress + '%';
        });
      })
      .catch(function () {});
  }

  var origFetch = window.fetch;
  window.fetch = function () {
    var args = arguments;
    var url = '';
    try {
      url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
    } catch (e) {}
    var result = origFetch.apply(this, args);
    if (url && /\/cart\/(add|change|update|clear)(\.|\?|$)/.test(url)) {
      result.then(function () { setTimeout(refresh, 200); }).catch(function () {});
    }
    return result;
  };

  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._nueUrl = url;
    return origOpen.apply(this, arguments);
  };
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    var xhr = this;
    if (xhr._nueUrl && /\/cart\/(add|change|update|clear)(\.|\?|$)/.test(xhr._nueUrl)) {
      xhr.addEventListener('load', function () { setTimeout(refresh, 200); });
    }
    return origSend.apply(this, arguments);
  };

  document.addEventListener('cart:updated', refresh);
  document.addEventListener('cart:refresh', refresh);
  document.addEventListener('cart:change', refresh);
})();